import React, { useState } from 'react';
import { Grid, Divider, Typography, TextField, Button, Avatar, createMuiTheme, ThemeProvider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress, IconButton, ListItemIcon } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import { Autocomplete, Box, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
import instance from '../../../../config/axiosInstance';
import { Add } from '@mui/icons-material';
import { event } from 'react-ga';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 14,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
    },
    TypographyDataLeft: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: -26
    },
    TextField: {
        width: '100%',
        height: '10%'
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
        height: '10%',
        backgroundColor: 'white',
        borderColor: '#c3c3c3',
        borderWidth: 1,
        borderRadius: 10,
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#c3c3c3',
            },
            '&:hover fieldset': {
                borderColor: '#c3c3c3',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#c3c3c3',
            },
        },
    },
    menuItem: {
        fontSize: 12,
        fontFamily: 'montserrat',
        color: '#686b72',
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: 10,
            },
            input: {
                padding: '11px 15px', // Aumente o padding para aumentar o tamanho
                width: '100%',
                marginLeft: '20px',
            },
        },
    },
});


const OfficeInformation = ({
    viewEmployeeRegistration,
    handleExpandClick
}) => {
    const classes = useStyles()

    const [isTitleVisible, setIsTitleVisible] = useState(true);


    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Divider style={{ marginTop: -20 }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={5} justify='flex-start'>
                        <TextField
                            key={viewEmployeeRegistration.office?.name}
                            select
                            value={viewEmployeeRegistration.office?.name}
                            onChange={event => viewEmployeeRegistration.handleChangeOfficeAndDepartment(event, 'officeId')}
                            variant="outlined"
                            className={classes.TextField}
                            InputProps={{
                                style: styles.InputLeft,
                                fontWeight: 'bold'
                            }}
                            label='Cargo (Obrigatório)'
                            InputLabelProps={{
                                style: {
                                    fontSize: '14px', // Diminuir o tamanho do label
                                    color: '#72727a', // Trocar a cor do label
                                    marginTop: -8, // Centralizar o label
                                    marginLeft: -10,
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            {viewEmployeeRegistration.officeList.map((option) => (
                                <MenuItem
                                    key={option.id}
                                    value={option.name}
                                >
                                    {option.id === 'addOffice' && (
                                        <ListItemIcon>
                                            <Add style={{ color: '#474eda' }} />
                                        </ListItemIcon>
                                    )}
                                    <ListItemText
                                        primary={option.name}
                                        className={classes.menuItem}
                                        style={{ fontFamily: 'montserrat', fontSize: 12, color: option.id === 'addOffice' ? '#474eda' : '#76797f' }}
                                    />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            key={viewEmployeeRegistration.department?.name}
                            select
                            value={viewEmployeeRegistration.department?.name}
                            onChange={event => viewEmployeeRegistration.handleChangeOfficeAndDepartment(event, 'departmentId')}
                            variant="outlined"
                            className={classes.TextField}
                            InputProps={{
                                style: {
                                    ...styles.InputRight,
                                    fontWeight: 'bold'
                                }
                            }}
                            label='Departamento (Obrigatório)'
                            InputLabelProps={{
                                style: {
                                    fontSize: '14px', // Diminuir o tamanho do label
                                    color: '#72727a', // Trocar a cor do label
                                    marginTop: -8, // Centralizar o label
                                }
                            }}
                        >
                            {viewEmployeeRegistration.departmentList.map((option) => (
                                <MenuItem
                                    key={option.id}
                                    value={option.name}
                                >
                                    {option.id === 'addDepartment' && (
                                        <ListItemIcon>
                                            <Add style={{ color: '#474eda' }} />
                                        </ListItemIcon>
                                    )}
                                    <ListItemText
                                        primary={option.name}
                                        className={classes.menuItem}
                                        style={{ fontFamily: 'montserrat', fontSize: 12, color: option.id === 'addDepartment' ? '#474eda' : '#76797f' }}

                                    />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyDataLeft}>
                            Data de Admissão (Obrigatório)
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            type="date"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.officeAndDepartmentInfo?.admission}
                            onChange={event => viewEmployeeRegistration.handleChangeOfficeAndDepartment(event, 'admission')}
                            InputProps={{
                                style: {
                                    ...styles.InputLeft,
                                    color: '#72727a',
                                    fontWeight: 'bold'

                                },
                                inputProps: {
                                    max: "9999-12-31", // Define o valor máximo permitido
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyData}>
                            PIS
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.officeAndDepartmentInfo?.pisCode}
                            onChange={event => viewEmployeeRegistration.handleChangeOfficeAndDepartment(event, 'pisCode')}
                            InputProps={{
                                style: {
                                    ...styles.InputRight,
                                    color: '#72727a',
                                    fontWeight: 'bold'
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyDataLeft}>
                            Matricula
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.officeAndDepartmentInfo?.enrollment}
                            onChange={event => viewEmployeeRegistration.handleChangeOfficeAndDepartment(event, 'enrollment')}
                            InputProps={{
                                style: {
                                    ...styles.InputLeft,
                                    color: '#72727a',
                                    fontWeight: 'bold'
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyData} style={{
                            color: viewEmployeeRegistration.optionsCity.find(option => option.name === viewEmployeeRegistration.selectedCity)
                                ? 'white' : isTitleVisible ? '#686b72' : 'white'
                        }}>
                            Local de Atuação (Obrigatório)
                        </Typography>
                        {/* <ThemeProvider theme={theme}> */}
                        <ThemeProvider theme={theme}>
                            <Autocomplete
                                id="city-search"
                                options={viewEmployeeRegistration.optionsCity}
                                getOptionLabel={(option) => option.name}
                                onInputChange={viewEmployeeRegistration.handleInputChangeCity}
                                onChange={(event, newValue) => {
                                    console.log(newValue ? newValue.name : 'Nenhuma cidade selecionada');
                                    viewEmployeeRegistration.setSelectedCity(newValue ? newValue.name : '');
                                    setIsTitleVisible(false);
                                }}
                                value={viewEmployeeRegistration.optionsCity.find(option => option.name === viewEmployeeRegistration.selectedCity) || null}
                                style={{ width: '107%' }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Busque por Estado ou Município"
                                        variant="outlined"
                                        InputLabelProps={{
                                            style: {
                                                fontSize: '14px',
                                                color: '#72727a',
                                                marginTop: -8,
                                                fontWeight: 'bold'
                                            }
                                        }}
                                    />}
                                onFocus={() => setIsTitleVisible(false)}
                                onBlur={() => setIsTitleVisible(true)}
                                renderOption={(props, option) => (
                                    <li {...props} key={`${option.city}-${option.state}`}>
                                        {option.name}
                                    </li>
                                )}
                            />

                        </ThemeProvider>
                        {/* </ThemeProvider> */}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider style={{ marginTop: 10 }} />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={7} container justify="flex-end" style={{ marginLeft: -10 }}>
                {
                    viewEmployeeRegistration.loading ?
                        <CircularProgress />
                        :
                        <>
                            <Button
                                style={{
                                    ...styles.buttonOne,
                                    color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : '#c3c3c3'
                                }}
                                onClick={() => viewEmployeeRegistration.handleClickDiscard('officeForm')}
                            >
                                Descartar atualizações
                            </Button>
                            <Button style={{
                                ...styles.buttonTwo,
                                backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : 'white',
                                color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton ? 'white' : '#c3c3c3'
                            }}
                                onClick={viewEmployeeRegistration.createdOfficeAndDepartment}
                            >
                                {viewEmployeeRegistration.isUpdate? 'Salvar': 'Próximo'}
                            </Button>
                        </>
                }
                <Box style={styles.Box} />
                <Avatar style={{ ...styles.avatar }}>
                    <IconButton onClick={() => handleExpandClick('office')}
                        style={{ padding: 0 }}
                    >
                        <ExpandMoreIcon style={{ fontSize: 20, color: viewEmployeeRegistration.isUpdate ? '#484fdb' : '#c3c3c3' }} />
                    </IconButton>
                </Avatar>
            </Grid>
            <Dialog
                open={viewEmployeeRegistration.openModalOffice}
                PaperProps={{
                    style: { borderRadius: 15 }
                }}
                onClose={viewEmployeeRegistration.handleCloseModalOffice}

            >
                <DialogTitle>
                    {viewEmployeeRegistration.office?.id == 'addOffice' ? 'Adicionar cargo' : 'Adicionar Departamento'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {`Por favor, preencha o campo a seguir com o nome do ${viewEmployeeRegistration.office?.id == 'addOffice' ? 'Cargo' : 'Departamento'}`}
                    </DialogContentText>
                    {/* <form onSubmit={handleSubmit}> */}
                    <TextField
                        autoFocus
                        margin="dense"
                        name="name"
                        label={'Cargo'}
                        onChange={event => viewEmployeeRegistration.setNameNewOffice(event.target.value)}
                        value={viewEmployeeRegistration.nameNewOffice}
                        type="text"
                        fullWidth
                        required
                    />
                    {/* </form> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={viewEmployeeRegistration.handleCloseModalOffice}
                    >
                        CANCELAR

                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={() => {
                            if (viewEmployeeRegistration.office?.id == 'addOffice') {
                                viewEmployeeRegistration.creatOffice()
                            } else if (viewEmployeeRegistration.department?.id == 'addDepartment') {
                                viewEmployeeRegistration.creatDepartment()
                            }
                        }}
                    >
                        CONFIRMAR
                    </Button>
                </DialogActions>
            </Dialog>

        </Grid >
    );
};


export default OfficeInformation;

const styles = {
    InputLeft: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginLeft: -26
    },
    InputRight: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginRight: -25
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold',
        whiteSpace: 'nowrap'
    },
    buttonTwo: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', color: '#c3c3c3', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' }
}
